import * as React from 'react';
import { connect } from 'react-redux';

import * as onboardingForm from 'login-utils/onboardingForm';
import LeftPane, { LeftPaneProps } from 'login-components/Common/PaneLayout/LeftPane/LeftPane';
import { getMilestonesLeftPaneCopy } from './milestonesUtils';

export class MilestonesLeftPane extends React.Component<LeftPaneProps> {
  render() {
    return <LeftPane {...this.props} />;
  }
}

export default connect((state: ReduxState) => {
  const loanType = onboardingForm.getLoanType(state);
  const timelineValue = onboardingForm.getTimelineValue(state);

  return getMilestonesLeftPaneCopy(loanType, timelineValue);
})(MilestonesLeftPane);
